import { createTheme } from '@mui/material/styles';
import colors from './data/colors';

export const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: colors.white
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true
      },
      styleOverrides: {
        tooltip: {
          fontSize: '1rem'
        }
      }
    }
  },
  palette: {
    primary: {
      main: colors.theme.primary
    },
    secondary: {
      main: colors.theme.secondary
    }
  }
});
